module.exports = __webpack_public_path__ + "img/ons.ac51b228.png";